// @ts-nocheck
import {
  SET_TABLE_COLUMN_VISIBILITY,
  RESET_TABLE_COLUMN_VISIBILITY,
  INITIALIZE_TABLE_COLUMNS,
} from "../constants/tableColumnVisibility";

export const initialState = {
  columnVisibility: {}, // { [tableId]: { [columnId]: boolean } }
};

const tableColumnVisibilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_TABLE_COLUMNS:
      return {
        ...state,
        columnVisibility: {
          ...state.columnVisibility,
          [action.payload.tableId]: action.payload.visibility,
        },
      };

    case SET_TABLE_COLUMN_VISIBILITY:
      return {
        ...state,
        columnVisibility: {
          ...state.columnVisibility,
          [action.payload.tableId]: action.payload.visibility,
        },
      };

    case RESET_TABLE_COLUMN_VISIBILITY:
      return {
        ...state,
        columnVisibility: {
          ...state.columnVisibility,
          [action.payload.tableId]: action.payload.visibility,
        },
      };

    default:
      return state;
  }
};

export default tableColumnVisibilityReducer;